/** Dirección pública para compartir, incluso al abrir el panel desde Workers. */
export const ORIGEN_PUBLICO = 'https://encancha.com.ar';
